import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7D818A",
      d: "M1.167 13.125c0-1.238.491-2.425 1.366-3.3S5.763 8.75 7 8.75c1.238 0 3.591.2 4.466 1.075a4.67 4.67 0 0 1 1.367 3.3h-1.167a3.5 3.5 0 0 0-1.025-2.475C9.985 9.994 7.928 9.917 7 9.917s-2.985.077-3.642.733a3.5 3.5 0 0 0-1.025 2.475zM7 7.875a3.5 3.5 0 0 1-3.5-3.5c0-1.934 1.566-3.5 3.5-3.5s3.5 1.566 3.5 3.5-1.566 3.5-3.5 3.5m0-1.167A2.333 2.333 0 1 0 7 2.043 2.333 2.333 0 0 0 7 6.708"
    }, null, -1)
  ]))]))
}
export default { render: render }